import {Board} from "../../models/types";
import React from "react";
import "./BoardInfo.css";

interface BoardInfoProps {
	board: Board;
}

type CounterSpec = {
	type: "columns" | "tasks" | "unsynced";
	count: ( board:Board) => number;
	label: string;
};
function getCounterSpec(): CounterSpec[] {
	return [
		{type: "columns", count: (board:Board) => board.columns.length, label: "колонок"},
		{type: "tasks", count: (board:Board) => board.tasks.length, label: "задач"},
		{type: "unsynced", count: (board:Board) => {
			return board.tasks.filter((t) => !t.isSynced).length;
		}, label: "не синхронизировано",},
	];
}



export class BoardInfo extends React.Component<BoardInfoProps, any> {
	private classBlock = "board-header-info";
	private renderSpec = getCounterSpec();

	private Counter = ({type, count, label}: CounterSpec	):React.ReactNode =>{
		const classElement = `${this.classBlock}__item`;
		const classIndicator = `${this.classBlock}__indicator`;
		const classModifier = `${classIndicator}--${type}`;

		return (
			<div className={classElement}>
				<span className={`${classIndicator} ${classModifier}`}></span>
				<span>{count(this.props.board)} {label}</span>
			</div>
		);
	}

	private renderUpdatedInfo(): React.ReactNode {
		const classElement = `${this.classBlock}__updated`;
		const classContainer = `${classElement}-container`;
		const updatedTime = new Date(this.props.board.updatedAt).toLocaleTimeString();

		return (
			<div className={classContainer}>
				<div className={classElement}>
					Обновлено: {updatedTime}
				</div>
			</div>
		);
	}

	render(): React.ReactNode {
		return (
			<div className={this.classBlock}>
				<div className={`${this.classBlock}__items`}>
					{this.renderSpec.map((info)=><this.Counter key={info.type}  {...info}/>)}
				</div>
				{this.renderUpdatedInfo()}
			</div>
		);
	}
}